import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import DownloadIcon from '@atlaskit/icon/core/download';
import { Anchor } from '@atlaskit/primitives/compiled/anchor';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { token } from '@atlaskit/tokens';

import { i18n } from '../attachmentsMacroi18n.ts';

const DOWNLOAD_ALL_PATH = '/wiki/download/all_attachments';

type DownloadAllLinkProps = {
	pageId: string;
};

const styles = cssMap({
	wrapper: {
		paddingBlockStart: token('space.150'),
	},
	link: {
		display: 'inline-flex',
		alignItems: 'center',
		color: token('color.link'),
		textDecoration: 'none',
	},
});

export const DownloadAllLink = ({ pageId }: DownloadAllLinkProps): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const href = `${DOWNLOAD_ALL_PATH}?pageId=${pageId}`;

	return (
		<Box xcss={styles.wrapper} testId="attachments-download-all">
			<Anchor href={href} title={formatMessage(i18n.downloadAllDesc)} xcss={styles.link}>
				<Inline space="space.050" alignBlock="center">
					<DownloadIcon label="" size="small" />
					<FormattedMessage {...i18n.downloadAll} />
				</Inline>
			</Anchor>
		</Box>
	);
};
